module.exports = __webpack_public_path__ + "img/access-personal-app.ef0f2506.svg";